import { useEffect, useState } from 'react'
import { ActiveFeatures, TTDFeatureFlag } from '@saas/interfaces/core'

function useTTDFlag(flagName: TTDFeatureFlag) {
    const [resultValue, setResultValue] = useState(false)
    const enabled = ActiveFeatures.includes(flagName) // useFlag(flagName)

    useEffect(() => {
        const result = ['staging', 'development'].includes(window._env_.REACT_APP_TTD_ENV) || enabled
        setResultValue(result)
    }, [enabled])

    return resultValue
}

export default useTTDFlag
